import useFormDataGetPageDataByRequest from '../../../@hooks/useFormDataGetPageDataByRequest'
import { inventoryTypeEnum } from '../config'
import service from '../../../@services'

export default function useGetStockBillList(type) {
  const _getListApi =
    service[type === inventoryTypeEnum.IN ? 'stockIn' : 'stockOut'].getStockList
  const { pageData, loading, getList } =
    useFormDataGetPageDataByRequest(_getListApi)
  return {
    pageData,
    loading,
    getList
  }
}
